<template>
	<div>
		<el-container>
			<el-container>
				<el-header>
					<el-form :inline="true">
						<el-form-item>
							<el-input
							  v-model="searchForm.machineNum"
							  placeholder="设备编号"
							  clearable
							  style="display: block; width: 150px;"
							>
							</el-input>
						</el-form-item>

						<el-form-item>
							<el-input
							  v-model="searchForm.shortName"
							  placeholder="设备别名"
							  clearable
							  style="display: block; width: 150px;"
							>
							</el-input>
						</el-form-item>

						<!--						<el-form-item>-->
						<!--							<el-select v-model="machineTypeIds" multiple collapse-tags placeholder="设备类型">-->
						<!--								<el-option v-for="machineType in machineTypeList" :label="machineType.machineTypeName"-->
						<!--										   :value="machineType.id" :key="machineType.id"></el-option>-->
						<!--							</el-select>-->
						<!--						</el-form-item>-->

						<el-form-item>
							<el-input
							  v-model="searchForm.ipAddress"
							  placeholder="IP地址"
							  clearable
							  style="display: block; width: 150px;"
							>
							</el-input>
						</el-form-item>

						<el-form-item>
							<el-select v-model="searchForm.isOnline" placeholder="请选择" clearable>
								<el-option
								  v-for="item in [
									{
										value: 1,
          								label: '在线'
									},
									{
										value: 0,
          								label: '离线'
									},
								  ]"
								  :key="item.value"
								  :label="item.label"
								  :value="item.value"
								  clearable
								  style="display: block; width: 150px;"
								>
								</el-option>
							</el-select>
						</el-form-item>

						<el-form-item>
							<el-button @click="getMachineList">搜索</el-button>
						</el-form-item>

						<el-form-item>
							<el-button type="primary" @click="addHandle()">新增</el-button>
						</el-form-item>
					</el-form>
				</el-header>

				<el-main>
					<el-table
					  v-loading='loading'
					  ref="multipleTable"
					  :data="tableData"
					  tooltip-effect="dark"
					  style="margin-top: -20px;"
					  :height="tableHeight"
					  :row-style="{height: '0px'}"
					  :cell-style="{padding: '2px'}"
					  :header-cell-style="{background: '#E6F2FE', height:'8px',padding:'8px'}"
					  border
					  stripe
					  @selection-change="handleSelectionChange">

						<el-table-column
						  type="selection"
						>
						</el-table-column>

						<el-table-column
						  prop="machineNum"
						  label="设备编号"
						  sortable
						  show-overflow-tooltip>
						</el-table-column>

						<el-table-column
						  prop="shortName"
						  label="设备别名"
						  sortable
						  show-overflow-tooltip>
						</el-table-column>

						<el-table-column
						  prop="ipAddress"
						  label="IP地址"
						  align="center"
						  show-overflow-tooltip>
						</el-table-column>

						<el-table-column
						  prop="current"
						  label="电流"
						  align="center"
						  show-overflow-tooltip>
						</el-table-column>

						<el-table-column
						  prop="voltage"
						  label="电压"
						  align="center"
						  show-overflow-tooltip>
						</el-table-column>

						<el-table-column
						  prop="nowPower"
						  label="瞬时功率"
						  align="center"
						  show-overflow-tooltip>
						</el-table-column>

						<el-table-column
						  prop="totalPower"
						  label="电表读数"
						  align="center"
						  show-overflow-tooltip>
						</el-table-column>

						<el-table-column
						  prop="ratedPower"
						  label="额定功率"
						  align="center"
						  show-overflow-tooltip>
						</el-table-column>

						<el-table-column
						  prop="deviation"
						  label="偏差量（%）"
						  align="center"
						  show-overflow-tooltip>
						</el-table-column>

						<el-table-column
						  label="柜门状态"
						  align="center"
						  show-overflow-tooltip
						>
							<template slot-scope="scope">
								<el-tag
								  :type="scope.row.iostatus ? 'danger' : 'success'"
								  disable-transitions>{{ scope.row.iostatus ? '开' : '关' }}
								</el-tag>
							</template>
						</el-table-column>

						<el-table-column
						  label="设备状态"
						  align="center"
						  show-overflow-tooltip
						>
							<template slot-scope="scope">
								<el-tag
								  :type="scope.row.isOnline ? 'success' : 'danger'"
								  disable-transitions>{{ scope.row.isOnline ? '在线' : '离线' }}
								</el-tag>
							</template>
						</el-table-column>

						<el-table-column
						  prop="onlineTime"
						  label="脱网时间"
						  sortable
						  show-overflow-tooltip>
						</el-table-column>

						<el-table-column
						  prop="icon"
						  fixed="right"
						  label="操作">

							<template slot-scope="scope">

								<el-button type="text" @click="editHandle(scope.row.id)">编辑</el-button>

							</template>
						</el-table-column>

					</el-table>

					<el-pagination
					  @size-change="handleSizeChange"
					  @current-change="handleCurrentChange"
					  layout="total, sizes, prev, pager, next, jumper"
					  :page-sizes="[10, 20, 50, 100]"
					  :current-page="current"
					  :page-size="size"
					  :total="total">
					</el-pagination>
				</el-main>
			</el-container>
		</el-container>

		<!--新增对话框-->
		<el-dialog
		  title="设备信息编辑"
		  :visible.sync="dialogVisible"
		  width="700px"
		  :before-close="handleClose"
		  :close-on-click-modal="false">

			<el-form :model="editForm" :rules="editFormRules" ref="editForm" label-width="100px" class="demo-editForm"
					 :inline="true">

				<el-form-item label="设备编号" prop="machineNum" label-width="100px">
					<el-input v-model="editForm.machineNum" autocomplete="off"></el-input>
				</el-form-item>

				<el-form-item label="设备别名" prop="shortName" label-width="100px">
					<el-input v-model="editForm.shortName" autocomplete="off"></el-input>
				</el-form-item>

				<el-form-item label="IP地址" prop="ipAddress" label-width="100px">
					<el-input v-model="editForm.ipAddress" autocomplete="off"></el-input>
				</el-form-item>

				<el-form-item label="额定功率" prop="ratedPower" label-width="100px">
					<el-input v-model="editForm.ratedPower" autocomplete="off"></el-input>
				</el-form-item>

				<el-form-item label="偏差率" prop="deviation" label-width="100px">
					<el-input v-model="editForm.deviation" autocomplete="off"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="resetForm('editForm')">取 消</el-button>
				<el-button type="primary" @click="submitForm('editForm')">确 定</el-button>
			</div>
		</el-dialog>

		<!--新增对话框-->
		<el-dialog
		  :title="selectedMachineInfo"
		  :visible.sync="mediumDialogVisible"
		  width="1000px"
		  :before-close="handleMediumFormClose"
		  :close-on-click-modal="false">

			<el-form :model="mediumForm" ref="mediumForm" label-width="100px" class="demo-editForm">

				<el-container style="margin-top: -20px;">
					<el-main style="flex: none;">
						<el-form :inline="true" style="margin-top: -20px;">
							<el-form-item>
								<el-input
								  v-model="newMediumVal"
								  placeholder="卡号/密码"
								  clearable
								>
								</el-input>
							</el-form-item>

							<el-form-item>
								<el-select v-model="newMediumType" placeholder="请选择类型">
									<el-option label="卡片" value="0"></el-option>
									<el-option label="单次密码" value="1"></el-option>
									<el-option label="固定密码" value="2"></el-option>
								</el-select>
							</el-form-item>

							<el-form-item>
								<el-date-picker
								  v-model="newMediumEndTime"
								  type="datetime"
								  value-format="yyyy-MM-dd HH:mm:ss"
								  placeholder="选择截止日期时间">
								</el-date-picker>
							</el-form-item>

							<el-form-item>
								<el-button type="primary" @click="bindMediumHandle">绑定</el-button>
							</el-form-item>
						</el-form>
						<el-table
						  ref="mediumTable"
						  :data="mediumData"
						  tooltip-effect="dark"
						  style="width: 100%; height: 370px; margin-top: -20px;"
						  :row-style="{height: '0px'}"
						  :cell-style="{padding: '2px'}"
						  :header-cell-style="{background: '#E6F2FE', height:'8px',padding:'8px'}"
						  border
						  stripe>

							<el-table-column
							  type="selection"
							  width="55">
							</el-table-column>

							<el-table-column
							  prop="mediumVal"
							  label="卡号/密码"
							  width="100">
							</el-table-column>

							<el-table-column
							  prop="mediumFlag"
							  label="类型"
							  width="80">
								<template slot-scope="scope">
									<el-tag size="small" v-if="(scope.row.mediumFlag === 0)" type="success">卡片
									</el-tag>
									<el-tag size="small" v-else-if="(scope.row.mediumFlag === 1)" type="danger">
										单次密码
									</el-tag>
									<el-tag size="small" v-else-if="(scope.row.mediumFlag === 2)" type="danger">
										固定密码
									</el-tag>
								</template>
							</el-table-column>

							<el-table-column
							  prop="statusFlag"
							  label="状态"
							  width="80">
								<template slot-scope="scope">
									<el-tag size="small" v-if="(scope.row.statusFlag === 1)" type="success">有效
									</el-tag>
									<el-tag size="small" v-else-if="(scope.row.statusFlag === 0)" type="danger">无效
									</el-tag>
								</template>
							</el-table-column>

							<el-table-column
							  prop="statusTime"
							  label="状态变动时间"
							  width="160"
							  show-overflow-tooltip>
							</el-table-column>

							<el-table-column
							  prop="regDate"
							  label="创建时间"
							  width="170">
							</el-table-column>

							<el-table-column
							  prop="endTime"
							  label="有效期"
							  width="160"
							  show-overflow-tooltip>
							</el-table-column>

							<el-table-column
							  prop="icon"
							  label="操作"
							  width="80">

								<template slot-scope="scope">
									<template>
										<el-popconfirm title="确定要解绑吗？"
													   @confirm="unBindMediumHandle(scope.row.id)">
											<el-button type="text" slot="reference">解绑</el-button>
										</el-popconfirm>
									</template>

								</template>
							</el-table-column>
						</el-table>
					</el-main>
				</el-container>
				<!-- <el-form-item>
					<el-button type="primary" @click="saveWhiteListHandle">保存</el-button>
					<el-button @click="resetForm('editForm')">取消</el-button>
				</el-form-item> -->
			</el-form>

			<div slot="footer" class="dialog-footer" style="margin-top: -50px;">
				<el-button type="primary" @click="resetMediumForm('mediumForm')">关 闭</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
export default {
	name: "ElectricityMeter",
	data() {
		return {
			loading: true,

			searchForm: {},
			delBtlStatu: true,

			total: 0,
			size: 10,
			current: 1,

			dialogVisible: false,
			editForm: {},
			mediumDialogVisible: false,
			mediumForm: {},

			tableData: [],
			mediumData: [],

			selectedIdentityId: '',
			machineTypeList: [],
			interfaceList: [],
			gatewayList: [],

			editFormRules: {
				machineNum: [
					{required: true, message: '请输入设备编号', trigger: 'blur'}
				],
				shortName: [
					{required: true, message: '请输入设备别名', trigger: 'blur'}
				],
				machineTypeId: [
					{required: true, message: '请选择设备类型', trigger: 'blur'}
				],
				interfaceId: [
					{required: true, message: '请选择接口协议', trigger: 'blur'}
				],
				locationId: [
					{required: true, message: '请选择安装位置', trigger: 'blur'}
				]
			},

			multipleSelection: [],

			permDialogVisible: false,
			permForm: {},
			defaultProps: {
				children: 'children',
				label: 'machineNum'
			},
			treeSelectLocationId: 0,
			selectedMachineInfo: '',
			bindMachineId: '',
			newMediumVal: '',
			newMediumType: '',
			newMediumEndTime: '',
			// permTreeData: []
			statusFlagOptions: [{
				value: '9',
				label: '全部'
			}, {
				value: '1',
				label: '正常'
			}, {
				value: '0',
				label: '禁用'
			}],
			statusFlagValue: '1',
			machineTypeIds: [],
			gatewayIds: [],
		}
	},
	computed: {
		tableHeight: function () {
			return screen.height > 900 ? 630 : 550
		}
	},
	created() {
		this.getMachineList()
		this.getMachineTypeList()
		this.getInterfaceList()
		this.getGatewayList()

		// this.$axios.get('/iot/machine/list').then(res => {
		// 	this.permTreeData = res.data.data
		// })
	},
	methods: {
		toggleSelection(rows) {
			if (rows) {
				rows.forEach(row => {
					this.$refs.multipleTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},
		handleSelectionChange(val) {
			console.log("勾选")
			console.log(val)
			this.multipleSelection = val;

			this.delBtlStatu = val.length == 0
		},

		handleSizeChange(val) {
			console.log(`每页 ${val} 条`);
			this.size = val
			this.getMachineList()
		},
		handleCurrentChange(val) {
			console.log(`当前页: ${val}`);
			this.current = val
			this.getMachineList()
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
			this.dialogVisible = false
			this.editForm = {}
		},
		resetMediumForm() {
			this.mediumDialogVisible = false
			this.mediumForm = {}
		},
		handleClose() {
			this.resetForm('editForm')
		},
		handleMediumFormClose() {
			this.resetForm('mediumForm')
		},
		locationSelectNodeClick(locationdata) {
			this.$set(this.editForm, "locationId", locationdata.id);
			this.$set(this.editForm, "locationFullName", locationdata.fullName);
			// console.log(deptdata);
		},
		getMachineList() {
			this.loading = true;
			this.$axios.get("/iot/machine/list", {
				params: {
					machineTypeIds: 21,
					machineNum: this.searchForm.machineNum,
					shortName: this.searchForm.shortName,
					ipAddress: this.searchForm.ipAddress,
					gatewayIds: this.gatewayIds + "",
					statusFlag: this.statusFlagValue,
					isOnline: this.searchForm.isOnline,
					current: this.current,
					size: this.size
				}
			}).then(res => {
				this.tableData = res.data.data.records
				this.size = res.data.data.size
				this.current = res.data.data.current
				this.total = res.data.data.total
				this.loading = false;
			})
		},

		getInterfaceList() {
			this.$axios.get("/iot/machine/interfacelist", {
				params: {
					current: 1,
					size: 100
				}
			}).then(res => {
				this.interfaceList = res.data.data.records
			})
		},

		getGatewayList() {
			this.$axios.get("/iot/machine/gatewaylist", {
				params: {
					current: 1,
					size: 2000
				}
			}).then(res => {
				this.gatewayList = res.data.data.records
			})
		},

		getMachineTypeList() {
			this.$axios.get("/iot/machine/typelist", {
				params: {
					current: 1,
					size: 1000
				}
			}).then(res => {
				this.machineTypeList = res.data.data.records
			})
		},

		getMediumList() {
			this.$axios.get("/iot/medium/list", {
				params: {
					machineId: this.bindMachineId,
					current: this.current,
					size: this.size
				}
			}).then(res => {
				this.mediumData = res.data.data.records
				this.size = res.data.data.size
				this.current = res.data.data.current
				this.total = res.data.data.total
			})
		},

		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					console.log(this.editForm);
					this.$axios.post('/iot/machine/' + (this.editForm.id ? 'update' : 'save'), this.editForm)
					  .then(res => {

						  this.$message({
							  showClose: true,
							  message: '恭喜你，操作成功',
							  type: 'success',
							  onClose: () => {
								  this.getMachineList()
							  }
						  });

						  this.dialogVisible = false
						  this.resetForm(formName)
					  })
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		addHandle() {
			// this.editForm.doorNum = 1
			// this.editForm.cardNum = 0
			// this.editForm.passwordNum = 0
			// this.editForm.fingerNum = 0
			// this.editForm.statusFlag = 1
			this.editForm.interfaceId = 3
			this.editForm.machineTypeId = 21
			this.dialogVisible = true
		},
		editHandle(id) {
			this.$axios.get('/iot/machine/info/' + id).then(res => {
				this.editForm = res.data.data

				this.dialogVisible = true
			})
		},
		mediumHandle(row) {
			this.bindMachineId = row.id;
			this.selectedMachineInfo = row.locationFullName + "(" + row.machineNum + ") 密码/卡片设置";
			this.newMediumVal = ''
			this.getMediumList()
			this.mediumDialogVisible = true
		},
		openHandle(id) {
			this.$axios.post("/cabinet/openTask", id).then(res => {
				this.$message({
					showClose: true,
					message: '恭喜你，操作成功',
					type: 'success',
					onClose: () => {
						// this.getMachineList()
					}
				});
			})
		},
		bindMediumHandle() {
			this.mediumForm.machineId = this.bindMachineId
			this.mediumForm.mediumFlag = this.newMediumType
			this.mediumForm.mediumVal = this.newMediumVal
			this.mediumForm.endDate = this.newMediumEndTime
			this.$axios.post('/iot/medium/bind', this.mediumForm)
			  .then(res => {

				  this.$message({
					  showClose: true,
					  message: '恭喜你，操作成功',
					  type: 'success',
					  onClose: () => {
						  this.getMediumList()
					  }
				  });
			  })
		},
		unBindMediumHandle(id) {
			this.$axios.post("/iot/medium/unbind", id).then(res => {
				this.$message({
					showClose: true,
					message: '恭喜你，操作成功',
					type: 'success',
					onClose: () => {
						this.getMediumList()
					}
				});
			})
		}
	}
}
</script>

<style scoped>

.el-pagination {
	float: right;
	margin-top: 22px;
}

.el-select {
	width: 96%;
}

.btn {
	display: flex;
	justify-content: right;

	/* .el-button:first-child {
		margin-right: 30px;
	} */
}
</style>